import React, {Component} from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import {Link} from 'react-router-dom';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import PropTypes from 'prop-types';

// import MyButton from '../../util/MyButton';
import DeleteScream from './DeleteScream';
import ScreamDialog from './ScreamDialog';
import LikeButton from './LikeButton';
import ReactPlayer from 'react-player';
// MUI Stuff
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
// Icons
// import ChatIcon from '@material-ui/icons/Chat';
// Redux
import {connect} from 'react-redux';

const styles = {
  card: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 20
  },
  image: {
    display: 'block',
    width: '130px',
    height: '100px'
  },
  content: {
    paddingTop: 0,
    paddingLeft: 15,
    paddingRight: 15,
    objectFit: 'cover',
    textAlign: 'center'
  },
  userName: {
    textAlign: 'left'
  }
};

class Scream extends Component {
  render() {
    dayjs.extend(relativeTime);
    const {
      classes,
      scream: {
        body,
        createdAt,
        userImage,
        userHandle,
        screamId,
        likeCount,
        commentCount,
        youtubeUrl,
        postImage
      },
      user: {
        authenticated,
        credentials: {handle}
      }
    } = this.props;

    const deleteButton =
      authenticated && userHandle === handle ? (
        <DeleteScream screamId={screamId} />
      ) : null;
    return (
      <Card className={classes.card}>
        <CardMedia
          image={userImage}
          title='Profile image'
          className={classes.image}
        />
        <CardContent className={classes.content}>
          <Typography
            variant='h5'
            component={Link}
            to={`/users/${userHandle}`}
            color='primary'
          >
            <div className={classes.userName}>{userHandle}</div>
          </Typography>
          {deleteButton}
          <Typography variant='body2' color='textSecondary'>
            {dayjs(createdAt).fromNow()}
          </Typography>
          <hr className='streep' />
          <Typography variant='body1'>{body}</Typography>
          {/* post image  */}
          {postImage === '' ? (
            ''
          ) : (
            <div className='postImageDiv'>
              <img className='postImage' src={postImage} alt='postImage' />
            </div>
          )}

          {/* Youtube component moet hier komen */}
          {youtubeUrl === '' ? (
            ''
          ) : (
            <div className='player-wrapper'>
              <ReactPlayer
                className='react-player'
                url={youtubeUrl}
                controls={true}
                width='auto'
              />
            </div>
          )}
          {likeCount === 1 ? (
            <>
              <LikeButton screamId={screamId} />
              <span className='spacie'>{likeCount} Like</span>
            </>
          ) : likeCount >= 1000 ? (
            <>
              <LikeButton screamId={screamId} />
              <span className='spacie'>{`${likeCount / 1000}K`} Likes</span>
            </>
          ) : likeCount >= 100 ? (
            <>
              <LikeButton screamId={screamId} />
              <span className='spacieK'>{likeCount} Likes</span>
            </>
          ) : (
            <>
              <LikeButton screamId={screamId} />
              <span className='spacie'>{likeCount} Likes</span>
            </>
          )}
          {commentCount === 1 ? (
            <span className='spacieLike'>{commentCount} comment</span>
          ) : likeCount >= 1000 ? (
            <span className='spacieG'>{commentCount} comments</span>
          ) : (
            <span className='spacieLike'>{commentCount} comments</span>
          )}
          {/* <span>{likeCount} Likes</span> */}
          {/* <MyButton tip='comments'>
            <ChatIcon color='primary' />
          </MyButton> */}
          {/* <span className='spacieLike'>{commentCount} comments</span> */}
          <ScreamDialog
            screamId={screamId}
            userHandle={userHandle}
            openDialog={this.props.openDialog}
          />
        </CardContent>
      </Card>
    );
  }
}

Scream.propTypes = {
  user: PropTypes.object.isRequired,
  scream: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  openDialog: PropTypes.bool
};

const mapStateToProps = state => ({
  user: state.user
});

export default connect(mapStateToProps)(withStyles(styles)(Scream));
